import "./policy-pages.css";

export default function TermsAndConditions() {
  return (
    <>
<section className="policy-page">
  <header className="policy-header">
    <a className="back-link" href="/">← Back to Home</a>
    <h1>Terms & Conditions</h1>
    <p>These Terms & Conditions govern your use of the Web5Solution website and services, including technology, blockchain, Web3, AI, automation, and software development services.</p>
  </header>

  <main className="policy-content">
    <p><strong>Last Updated:</strong> 26 June 2026</p>

    <div className="notice">
      By accessing our website or engaging with our services, you agree to these Terms & Conditions.
    </div>

    <h2>1. About Web5Solution</h2>
    <p>Web5Solution provides technology services including blockchain development, Web3 solutions, smart contract development, AI solutions, automation, software development, website development, application development, and related digital services.</p>

    <h2>2. Use of Website</h2>
    <p>You agree to use our website only for lawful purposes. You must not:</p>
    <ul>
      <li>Use the website for fraudulent, harmful, or illegal activities</li>
      <li>Attempt to hack, damage, overload, or disrupt the website</li>
      <li>Copy, reproduce, or misuse website content without permission</li>
      <li>Upload or transmit viruses, malware, or harmful code</li>
      <li>Misrepresent your identity, business, or project requirements</li>
    </ul>

    <h2>3. Services</h2>
    <p>Our services may include, but are not limited to:</p>
    <ul>
      <li>Blockchain development</li>
      <li>Smart contract development</li>
      <li>Web3 development</li>
      <li>AI and automation solutions</li>
      <li>Software development</li>
      <li>Website and application development</li>
      <li>Consulting and technology strategy</li>
    </ul>
    <p>The exact scope, pricing, timeline, deliverables, and responsibilities will be defined separately in a proposal, quotation, invoice, agreement, or statement of work.</p>

    <h2>4. Proposals and Project Scope</h2>
    <p>Any proposal, estimate, or quotation provided by Web5Solution is based on the information available at the time.</p>
    <p>If project requirements change, additional work may require additional charges and revised timelines.</p>
    <p>We are not responsible for delays caused by incomplete information, delayed approvals, third-party issues, client-side dependencies, or changes requested by the client.</p>

    <h2>5. Client Responsibilities</h2>
    <p>When working with us, you agree to:</p>
    <ul>
      <li>Provide accurate and complete project information</li>
      <li>Share required content, assets, credentials, and approvals on time</li>
      <li>Review deliverables within agreed timelines</li>
      <li>Ensure that materials provided by you do not violate third-party rights</li>
      <li>Make payments according to agreed terms</li>
    </ul>

    <h2>6. Payments</h2>
    <p>Payment terms will be mentioned in the relevant proposal, invoice, or agreement.</p>
    <p>Unless otherwise agreed in writing:</p>
    <ul>
      <li>Work may begin only after advance payment is received</li>
      <li>Delayed payments may delay project delivery</li>
      <li>Completed work, milestones, or approved deliverables may not be refundable</li>
      <li>Additional features, revisions, or scope changes may be charged separately</li>
    </ul>

    <h2>7. Refund Policy</h2>
    <p>Refunds, if applicable, will depend on the project stage, work completed, resources allocated, and terms agreed in writing.</p>
    <p>No refund will be provided for completed milestones, delivered work, approved designs, deployed code, consultation time, or third-party costs.</p>

    <h2>8. Intellectual Property</h2>
    <p>Unless otherwise agreed in writing:</p>
    <ul>
      <li>Website content, graphics, branding, and materials owned by Web5Solution remain our property</li>
      <li>Client-provided content remains the client’s property</li>
      <li>Final project ownership may be transferred to the client after full payment is received</li>
      <li>Web5Solution may retain rights to reusable code, frameworks, libraries, tools, methods, and internal processes developed before or during the project</li>
    </ul>

    <h2>9. Portfolio Rights</h2>
    <p>Unless the client requests confidentiality in writing, Web5Solution may display completed work, project name, screenshots, case studies, or general project descriptions in its portfolio, website, social media, or marketing materials.</p>

    <h2>10. Third-Party Services</h2>
    <p>Projects may require third-party services such as hosting, cloud platforms, APIs, payment gateways, blockchain networks, analytics tools, plugins, or external software.</p>
    <p>We are not responsible for:</p>
    <ul>
      <li>Third-party downtime</li>
      <li>Third-party pricing changes</li>
      <li>API changes or service limitations</li>
      <li>Security issues caused by third-party platforms</li>
      <li>Account suspensions or restrictions by third-party providers</li>
    </ul>
    <p>Any third-party charges are the client’s responsibility unless agreed otherwise.</p>

    <h2>11. Blockchain and Web3 Disclaimer</h2>
    <p>Blockchain, cryptocurrency, smart contracts, tokens, NFTs, DeFi, and Web3 technologies may involve financial, technical, regulatory, and security risks.</p>
    <p>Web5Solution does not provide financial, investment, legal, or tax advice. Clients are responsible for ensuring that their blockchain or Web3 project complies with applicable laws and regulations.</p>
    <p>We are not responsible for losses caused by market volatility, wallet misuse, private key loss, smart contract exploitation, blockchain network issues, irreversible transactions, or regulatory actions.</p>

    <h2>12. AI Services Disclaimer</h2>
    <p>AI systems may produce inaccurate, incomplete, biased, or unexpected outputs. Any AI-based solution should be reviewed, tested, and monitored before production use.</p>
    <p>Web5Solution does not guarantee that AI-generated outputs will always be accurate, error-free, or suitable for every business decision.</p>

    <h2>13. Confidentiality</h2>
    <p>Both parties may receive confidential business, technical, or project-related information.</p>
    <p>We agree to take reasonable steps to protect confidential information and not disclose it to unauthorized parties, except where required by law or necessary to deliver services.</p>

    <h2>14. Limitation of Liability</h2>
    <p>To the maximum extent permitted by law, Web5Solution will not be liable for:</p>
    <ul>
      <li>Indirect, incidental, special, or consequential losses</li>
      <li>Loss of profits, revenue, data, business opportunity, or goodwill</li>
      <li>Website downtime or third-party service failures</li>
      <li>Security incidents caused by client negligence</li>
      <li>Issues caused by incorrect or incomplete information provided by the client</li>
      <li>Losses related to blockchain transactions, crypto assets, wallets, or smart contracts</li>
    </ul>
    <p>Our total liability, if any, will not exceed the amount paid by the client for the specific service giving rise to the claim.</p>

    <h2>15. No Guarantee of Results</h2>
    <p>We aim to provide high-quality services, but we do not guarantee specific business results, rankings, revenue, funding, user growth, investment returns, or market success.</p>

    <h2>16. Termination</h2>
    <p>We may suspend or terminate services if:</p>
    <ul>
      <li>The client fails to make payment</li>
      <li>The client provides false, misleading, or illegal requirements</li>
      <li>The client violates these Terms</li>
      <li>The project involves unlawful, harmful, or unethical activity</li>
      <li>Continued work becomes commercially, legally, or technically unreasonable</li>
    </ul>
    <p>The client may also terminate the project by providing written notice. Payment will remain due for work completed up to the termination date.</p>

    <h2>17. Website Content</h2>
    <p>The content on our website is provided for general information only. We may update, remove, or change website content at any time without prior notice.</p>
    <p>We do not guarantee that all website content is complete, accurate, or up to date at all times.</p>

    <h2>18. Governing Law</h2>
    <p>These Terms & Conditions shall be governed by the laws of India.</p>
    <p>Any disputes shall be subject to the jurisdiction of the competent courts in Gurugram, Haryana, India, unless otherwise agreed in writing.</p>

    <h2>19. Changes to Terms</h2>
    <p>We may update these Terms & Conditions from time to time. Updated terms will be posted on this page with a revised “Last Updated” date.</p>
    <p>Your continued use of our website or services means you accept the updated Terms.</p>

    <h2>20. Contact Us</h2>
    <div className="contact-box">
      <p><strong>Web5Solution</strong></p>
      <p>Email: <a href="mailto:info@web5solution.com">info@web5solution.com</a></p>
      <p>Website: <a href="https://web5solution.com/">https://web5solution.com/</a></p>
      <p>Address: 19A, Ground Floor, Tower B3, Spaze i-Tech Park, Sohna Road, Sector 49, Gurugram, Haryana 122018, India</p>
    </div>
  </main>

  
</section>
    </>
  );
}
